var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group field-input-container" }, [
    _vm.$attrs.type === "password"
      ? _c("i", {
          ref: "showPassword",
          class: [
            "far fa-eye-slash m-auto show-password",
            {
              "lang-en": _vm.isEN
            }
          ],
          on: { click: _vm.showPass }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "input",
      _vm._g(
        _vm._b(
          {
            ref: "input",
            class: [
              "form-control",
              [_vm.inputClass],
              {
                ltr: _vm.number,
                fanum: !_vm.isEN,
                error: _vm.error
              }
            ],
            style: _vm.style.input,
            attrs: {
              title: _vm.label,
              autocomplete: _vm.autocompleteOff ? "new-password" : null
            },
            domProps: { value: _vm.formattedValue }
          },
          "input",
          _vm.$attrs,
          false
        ),
        _vm.inputListeners
      )
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "placeholder unselectable form-label",
          _vm.placeholderClass,
          {
            "fix-label": _vm.fixLabel,
            "lang-en": _vm.isEN
          }
        ],
        on: {
          click: function($event) {
            _vm.fixLabel ? null : _vm.$refs.input.focus()
          }
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
        _vm.help
          ? _c("i", {
              staticClass: "fa fa-question-circle fa-flip-horizontal",
              staticStyle: { cursor: "pointer" },
              attrs: { id: _vm.helpPopoverId }
            })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.error || _vm.serverError
      ? _c("div", {
          class: ["error-text d-inline-block mt-2 mb-1", { fanum: !_vm.isEN }],
          attrs: { id: _vm.$attrs.name + "_error" },
          domProps: { innerHTML: _vm._s(_vm.error || _vm.serverError) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }